module.exports = __webpack_public_path__ + "r-v3/img/ico_option_radio_checked.0b1e1e04.svg";